"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../form-input-field/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ConfigSelectList = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfigSelectList, _React$Component);

  function ConfigSelectList(props) {
    _classCallCheck(this, ConfigSelectList);

    return _possibleConstructorReturn(this, (ConfigSelectList.__proto__ || Object.getPrototypeOf(ConfigSelectList)).call(this, props));
  }

  _createClass(ConfigSelectList, [{
    key: "render",
    value: function render() {
      var _this = this;

      var currentUser = this.props.users.filter(function (user) {
        return user.id === _this.props.currentPersonId;
      })[0];

      if (!currentUser) {
        return null;
      }

      var initialIds = currentUser[this.props.type].map(function (item) {
        return parseInt(item.id);
      });
      var items = this.props.items.map(function (item, key) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: key
        }, /*#__PURE__*/_react.default.createElement(_index.default, {
          name: "".concat(_this.props.type, "-").concat(item.id),
          label: item.name,
          isEditable: true,
          type: "checkbox",
          onChange: function onChange(e) {
            _this.props.onChange(_this.props.currentPersonId, item.id, !e.target.checked);
          },
          value: initialIds.indexOf(parseInt(item.id)) > -1
        }));
      });
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, currentUser.first_name, " ", currentUser.last_name), /*#__PURE__*/_react.default.createElement("ul", {
        className: "project-select"
      }, items));
    }
  }]);

  return ConfigSelectList;
}(_react.default.Component);

ConfigSelectList.propTypes = {
  users: _propTypes.default.array.isRequired,
  currentPersonId: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  items: _propTypes.default.array,
  type: _propTypes.default.string.isRequired
};
var _default = ConfigSelectList;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/settings-user-management/config-select-list.js
// module id = 726
// module chunks = 0